import React from 'react';
import cn from 'classnames';
import { useEditorContainerSize } from '@wix/da-editor-tiptap/pkg/components/Editor/Context';
import StatusDumbView from '../../../DeviationViews/Dumbo/Status';
import EditorDeviationLink from '../_partials/DeviationLink';
import { useFreeformSquareSizing } from '../helpers';
import s from './Status.scss';
const StatusMonoView = (props)=>{
    const containerSize = useEditorContainerSize();
    const { deviation, extOptions, width: propsWidth, link } = props;
    const size = useFreeformSquareSizing(propsWidth, extOptions, containerSize);
    return /*#__PURE__*/ React.createElement("div", {
        className: cn(s['root']),
        style: {
            width: size.width
        }
    }, /*#__PURE__*/ React.createElement(EditorDeviationLink, {
        link: link,
        deviation: deviation
    }, /*#__PURE__*/ React.createElement(StatusDumbView, {
        width: size.width,
        height: size.height,
        deviation: deviation
    })));
};
StatusMonoView.displayName = 'StatusMonoView';
export default StatusMonoView;

//# sourceMappingURL=Status.js.map